var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.content)?[_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.handleLinkClick}})]:_vm._e(),_c('safe-area-bottom')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }